import { registerRootComponent } from 'expo';
import App from './src/app/App';
import 'mapbox-gl/dist/mapbox-gl.css';

registerRootComponent(App);
